module.exports = __webpack_public_path__ + "img/reject-portrait.5cc31a7.png";